import { Theme } from '@mui/material'

import { SHORT_SCREEN_HEIGHT } from '../../utils/constants'

const useStyles = {
  animation: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      maxHeight: 'calc(100vh - 148px)',
      marginLeft: '-16px',
      marginRight: '-16px',
      marginTop: '-100px',
    },
    // Extra rule for short screens - shrink more and scale down more
    [`@media (max-height:${SHORT_SCREEN_HEIGHT})`]: {
      marginTop: '-50px',
      maxHeight: 'calc(100vh - 140px)',
      transform: 'scale(0.7)',
      transformOrigin: 'top center',
    },
  }),
}

export default useStyles
